export enum BidModel {
  CostPerApplyClick = 'CostPerApplyClick',
  CostPerApplication = 'CostPerApplication',
}
